import { Injectable } from '@angular/core';
import { AnswersDataService } from '@services/answers-data.service';
import { ProfileStepCode } from '@shared/models/profile-step-code';
import { map } from 'rxjs/operators';
import {
  MonitoringClient,
  WithdrawnProfile,
  WithdrawnSubscriptionsResponse
} from '../MIF.Subscription.WebApi';

@Injectable({
  providedIn: 'root'
})
export class MonitoringService {
  constructor(
    private webApi: MonitoringClient,
    private answersDataService: AnswersDataService
  ) {}

  public async getWithdrawnSubscriptions(): Promise<WithdrawnSubscriptionsResponse> {
    return this.webApi
      .getWithdrawnSubscriptions()
      .pipe(
        map((response: WithdrawnSubscriptionsResponse) => {
          response.withdrawnProfiles.forEach(
            (subscription: WithdrawnProfile) => {
              subscription.abandonmentStep =
                this.answersDataService.getLatestStepRoute(
                  subscription.abandonmentStep as ProfileStepCode
                );
            }
          );
          response.withdrawnProfiles.sort((a, b) =>
            a.abandonmentDate < b.abandonmentDate ? 1 : -1
          );
          return response;
        })
      )
      .toPromise();
  }
}
